<script>
import layout from '@src/mixins/layout.vue'
import moment from 'moment'

import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import { providerService } from '@/src/services/safehaven/ProviderService'
import TimeTile from '@components/time-tile.vue'

export default {
  components: { TimeTile },
  mixins: [layout, NavigateMixin],
  emits: ['close-dialog'],
  props: {
    showDetails: {
      type: Boolean,
      default: false,
      required: true,
    },
    providerDetails: {
      type: Object,
      default(rawProps) {
        return {}
      },
    },
    selectedDate: {
      type: String,
      default: '',
      required: true,
    },
    isFromReschedule: {
      type: Boolean,
      default: false,
      required: false,
    },
    appointmentDetails: {
      type: Object,
      default(rawProps) {
        return {}
      },
      required: false,
    },
  },
  data() {
    return {
      currMonth: moment().format('MMMM'),
      nOD: moment(this.selectedDate).format('MMMM D'),
      todayDate: moment().format('MMMM D'),
      now: moment()
        .format('YYYY-MM-DD')
        .toString(),
      timeSlots: [],
      isTimeBefore: true,
      loading: false,
    }
  },
  updated: function() {
    this.nOD = moment(this.selectedDate).format('MMMM D')
    this.isTimeBefore = moment(this.selectedDate).isBefore(this.now)
  },

  methods: {
    dismissDialog() {
      this.showDetails = false
      this.$emit('close-dialog')
    },
    async getUpdatedProviderDetails() {
      this.loading = true
      const providerDetailReqObj = {
        provider_type: this.providerDetails.speciality,
        date: this.selectedDate,
        provider_id: this.providerDetails.provider_id,
      }
      providerService.getProviderDetails(providerDetailReqObj).then((res) => {
        const response = this.parseResponse(res.data)
        this.providerDetails = response[0]
        this.loading = false
      })
    },
    parseResponse(resData) {
      resData.map((provider) => {
        provider.credentials = this.getCredentials(provider.credentials)
      })
      return resData
    },
    getCredentials(credArr) {
      let credentials = ''
      credArr.map((cred) => {
        credentials = credentials + ', ' + cred.credential_name
      })
      return credentials
    },
    bookMeeting(timeSlot, provider) {
      this.providerDetails.selectedTimeSlot = timeSlot
      this.providerDetails.selectedDate = this.selectedDate

      if (this.isFromReschedule) {
        this.$router.push({
          name: 'confirm-appointment',
          params: {
            selectedProviderDetails: this.providerDetails,
            appointmentDetails: this.appointmentDetails,
            isFromReschedule: this.isFromReschedule,
          },
        })
      } else {
        this.$router.push({
          name: 'confirm-appointment',
          params: { selectedProviderDetails: this.providerDetails },
        })
      }
    },
    nextDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D')
      this.providerDetails.available_slots = []
      this.getUpdatedProviderDetails()
    },
    previousDate() {
      this.selectedDate = moment(this.selectedDate)
        .add(-1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.nOD = moment(this.selectedDate).format('MMMM D')
      this.providerDetails.available_slots = []
      this.getUpdatedProviderDetails()
    },
  },
}
</script>

<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDetails"
      scrollable
      persistent
      min-width="300"
      max-width="600"
      no-click-animation
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
      :fullscreen="mobile"
    >
      <v-card :class="$style.dialogContainer">
        <v-card-title class="ma-0">
          <v-img
            class="rounded-lg mt-2"
            height="25"
            contain
            :class="$style.closeIcon"
            :src="require('@assets/images/safehaven/cross.png')"
            @click="dismissDialog"
          >
          </v-img>
        </v-card-title>

        <v-card-text :class="$style.detailsContainer" class="text-center">
          <v-col>
            <v-row :class="$style.topContainer">
              <div>
                <v-img
                  class="rounded-lg mt-2"
                  :class="$style.providerImage"
                  contain
                  :src="
                    providerDetails.profile_picture_url === ''
                      ? require('@assets/images/safehaven/sample_avatar.jpg')
                      : providerDetails.profile_picture_url
                  "
                  alt=""
                >
                </v-img>
              </div>
              <div>
                <div :class="$style.textContainer">
                  <p :class="$style.appointmentText"
                    >{{ providerDetails.first_name }}
                    {{ providerDetails.last_name
                    }}{{ providerDetails.credentials }}</p
                  >
                  <p :class="$style.titleText">
                    {{ providerDetails.speciality }}
                  </p>
                  <p :class="$style.stateText"
                    >{{ providerDetails.city }}, {{ providerDetails.state }}</p
                  >
                </div>
              </div>
            </v-row>

            <div :class="$style.timeslotContainer">
              <div :class="$style.dateSlider">
                <v-carousel hide-delimiters :class="$style.carouselContaner">
                  <template v-slot:prev="{ on, attrs }">
                    <v-icon
                      color="#0476D9"
                      style="background-color: #f2f9ff"
                      v-bind="attrs"
                      v-on="on"
                      @click="previousDate"
                      >mdi-less-than</v-icon
                    >
                  </template>
                  <template v-slot:next="{ on, attrs }">
                    <v-icon
                      color="#0476D9"
                      style="background-color: #f2f9ff"
                      v-bind="attrs"
                      v-on="on"
                      @click="nextDate"
                      >mdi-greater-than</v-icon
                    >
                  </template>
                  <v-carousel-item v-for="(item, i) in nOD" :key="i">
                    <v-row
                      :class="$style.carouselItem"
                      align="center"
                      justify="center"
                    >
                      <div>
                        <span v-if="todayDate === nOD">Today, </span>
                        {{ nOD }}</div
                      >
                    </v-row>
                  </v-carousel-item>
                </v-carousel>
              </div>
              <div :class="$style.loaderContainer">
                <v-progress-linear
                  v-if="loading"
                  class="mt-6"
                  :class="$style.liststyle"
                  color="blue"
                  indeterminate
                  rounded
                  height="2"
                ></v-progress-linear>
                <v-row
                  v-if="
                    !isTimeBefore &&
                      providerDetails.available_slots &&
                      providerDetails.available_slots.slot &&
                      providerDetails.available_slots.slot.length > 0
                  "
                  :class="$style.timeSlotRow"
                >
                  <TimeTile
                    v-for="(timeSlot, ind) in providerDetails.available_slots
                      .slot"
                    :key="ind"
                    :time-slot="timeSlot.start_time"
                    :is-booked="timeSlot.isBooked"
                    :selected-date="providerDetails.available_slots.date"
                    @time-selected="bookMeeting(timeSlot, providerDetails)"
                  />
                </v-row>
                <div v-else :class="$style.noTimeContainer">
                  <p>No availability</p>
                </div>
              </div>
            </div>
            <div :class="$style.descriptionContainer">
              <p :class="$style.descriptionTitle"
                >About {{ providerDetails.first_name }}
                {{ providerDetails.last_name }}
              </p>
              <p :class="$style.descriptionText"
                >{{ providerDetails.biography }}
              </p>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';

.dialogMenu {
  border-radius: 9px !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.dialogContainer {
  height: 600px;
  background-color: white !important;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}

.closeIcon {
  position: absolute;
  right: 25px;
  height: 21px;
  cursor: pointer;
}

.topContainer {
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
}

.providerImage {
  width: 130px;
  height: 100px;
}

.textContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 370px;
  margin-top: 5px;
  text-align: left;
}

.titleText {
  margin-bottom: 0 !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  color: #2c3a4b;
}

.stateText {
  font-size: 14px;
  font-weight: 400;
  line-height: 23px;
  text-align: left;
  letter-spacing: -0.30000001192092896px;
}

.appointmentText {
  margin-bottom: 0 !important;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  color: #09101d;
  letter-spacing: -0.3px;
}

.timeslotContainer {
  display: flex;
  flex-direction: column;
  min-height: 320px;
  background-color: #f2f9ff !important;
  border: 1px solid #d1dfeb;
}

.dateSlider {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.carouselContaner {
  height: 50px !important;
}

.carouselItem {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0;
}

.timeSlotRow {
  padding: 5px;
  margin-right: 2px;
  margin-left: 1px;
}

.noTimeContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
}

.dateText {
  margin-bottom: 5px !important;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  color: #000;
  text-align: center;
  background-color: transparent !important;
}

.theme--light.v-icon {
  color: blue;
}

.descriptionContainer {
  margin-top: 10px;
}

.descriptionTitle {
  margin-bottom: 5px !important;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  color: #09101d;
  text-align: left;
}

.descriptionText {
  font-size: 15px;
  color: #09101d;
  text-align: justify;
}

.liststyle {
  width: 50%;
  margin-bottom: 20px;
}

.loaderContainer {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
}

@media screen and (max-width: 960px) {
  .topContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5px;
  }

  .timeslotContainer {
    min-height: 370px;
  }

  .textContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    text-align: center;
  }

  .stateText {
    text-align: center;
  }
}
</style>
